/**
 * The API token kept in localStorage between visits (redux/user/authSlice.js) is
 * reused only if this build's login issued it. One stored before the move to
 * auth.scalens.com came from praexo, and connect refuses it after the switch.
 */
export function isFromThisLogin(token, domain = process.env.REACT_APP_TESTING_DOMAINE) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return Boolean(domain) && payload.iss === `https://${domain}/`;
  } catch {
    return false;
  }
}
